import env from "../env"

let winStatusUpdateHandlerAdd = function() { console.log("skip add window status update handler cause by NOT electron") }
let getFocusedWinStatus = function() { return null }
let setWinMin = function() { console.log("skip set window minimize cause NOT electron") }
let setWinMax = function() { console.log("skip set window maximize cause NOT electron") }
let setWinUnMax = function() { console.log("skip set window unMaximize cause NOT electron") }
let setWinClose = function() { console.log("skip set window close cause NOT electron") }
let toggleMaxWinOnMac = function () { console.log("skip toggle Max Win On Mac cause NOT electron") }
let exitService = function () { console.log("skip exit service cause NOT electron") }

if (env.isElectron) {
    const { ipcRenderer } = window.require("electron")

    let winStatusUpdateHandlers = []
    winStatusUpdateHandlerAdd = function(cb) {
        winStatusUpdateHandlers.push(cb)
    }
    ipcRenderer.on('update-win-status', (event, status) => {
        console.log("update-win-status: event:", event)
        console.log("update-win-status: status:", status)
        winStatusUpdateHandlers.forEach((cb) => {cb(status)})
    })

    getFocusedWinStatus = function() {return ipcRenderer.sendSync('getFocusedWinStatus')}

    setWinMin = function() { ipcRenderer.send('setWinMin') }
    setWinMax = function() { ipcRenderer.send('setWinMax') }
    setWinUnMax = function() { ipcRenderer.send('setWinUnMax') }
    setWinClose = function() { ipcRenderer.send('setWinClose') }
    toggleMaxWinOnMac = function () { if (env.running.isDarwin()) getFocusedWinStatus() === "max" ? setWinUnMax() : setWinMax() }
    exitService = function (reason) { ipcRenderer.send('exitService', reason) }
}

// window status: "max"/"normal"

export default {
    getFocusedWinStatus,
    winStatusUpdateHandlerAdd,
    setWinMin,
    setWinMax,
    setWinUnMax,
    setWinClose,
    toggleMaxWinOnMac,
    exitService,        // 退出桌面服务
}
